import React from 'react';
import { Globe, AlertCircle, Heart, Target } from 'lucide-react';

const CoreThemes = () => {
  const themes = [
    {
      icon: Globe,
      title: 'Hybrid Warfare & the Mind',
      description: 'Modern conflicts increasingly target perception, emotion, and belief rather than territory alone.',
      image: 'https://images.unsplash.com/photo-1764990189201-8025ff64d981?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxtZW50YWwlMjByZXNpbGllbmNlfGVufDB8fHx8MTc3MTE4ODM3NHww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: AlertCircle,
      title: 'Misinformation as Psychological Stress',
      description: 'False narratives and information overload erode trust, clarity, and emotional stability.',
      image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtZW50YWwlMjBjbGFyaXR5fGVufDB8fHx8MTc3MTE4ODM5MXww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Heart,
      title: 'Mental Resilience',
      description: 'Listeners learn how to strengthen psychological defenses through awareness and critical thinking.',
      image: 'https://images.unsplash.com/photo-1522075782449-e45a34f1ddfb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxjb250ZW1wbGF0aW9ufGVufDB8fHx8MTc3MTE4ODM4Mnww&ixlib=rb-4.1.0&q=85'
    },
    {
      icon: Target,
      title: 'Truth as a Form of Self-Defense',
      description: 'Safeguarding mental health begins with the ability to discern truth from manipulation.',
      image: 'https://images.unsplash.com/photo-1765438858380-7cd73d0dca60?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwzfHxtZW50YWwlMjBjbGFyaXR5fGVufDB8fHx8MTc3MTE4ODM5MXww&ixlib=rb-4.1.0&q=85'
    }
  ];

  return (
    <section id="themes" className="themes-section">
      <div className="section-container">
        <div className="section-header">
          <h2 className="section-title">Core Themes</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Essential concepts explored throughout the audiobook
          </p>
        </div>
        
        <div className="themes-grid">
          {themes.map((theme, index) => (
            <div key={index} className="theme-card">
              <div className="theme-image-wrapper">
                <img 
                  src={theme.image} 
                  alt={theme.title}
                  className="theme-image"
                />
                <div className="theme-overlay"></div>
              </div>
              <div className="theme-content">
                <div className="theme-icon">
                  <theme.icon size={32} />
                </div>
                <h3 className="heading-4">{theme.title}</h3>
                <p className="body-small">{theme.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoreThemes;
